// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-detail-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 24px;
  background: #f5f5f5;
  min-height: 100vh;
}
.back-btn {
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 18px;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 24px;
}
.order-info {
  background: #fff;
  border-radius: 10px;
  padding: 28px 22px;
  margin-bottom: 32px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}
.order-info > div {
  margin-bottom: 7px;
  font-size: 15px;
}
.slideshow {
  background: #fff;
  border-radius: 10px;
  padding: 24px 18px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}
.slides-wrapper {
  display: flex;
  gap: 18px;
  overflow-x: auto;
  padding-bottom: 8px;
}
.slide-img {
  max-width: 320px;
  max-height: 220px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrderDetailPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC","sourcesContent":[".order-detail-page {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 40px 24px;\n  background: #f5f5f5;\n  min-height: 100vh;\n}\n.back-btn {\n  background: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 18px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-bottom: 24px;\n}\n.order-info {\n  background: #fff;\n  border-radius: 10px;\n  padding: 28px 22px;\n  margin-bottom: 32px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.08);\n}\n.order-info > div {\n  margin-bottom: 7px;\n  font-size: 15px;\n}\n.slideshow {\n  background: #fff;\n  border-radius: 10px;\n  padding: 24px 18px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.08);\n}\n.slides-wrapper {\n  display: flex;\n  gap: 18px;\n  overflow-x: auto;\n  padding-bottom: 8px;\n}\n.slide-img {\n  max-width: 320px;\n  max-height: 220px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
